<template>
    <div class="face-rate">
        <div class="header-logo">
            <a @click="homePage">
                <img src="@/assets/icons/login__logo.svg" alt="">
            </a>
        </div>
        <div v-if="this.$route.params.confirm == 'cancel'">
            <div class="user-info">
                <div class="reset-status">
                    <div v-if="resetCancelCodeSuccess">
                        {{translate('resetPasswordRequestCancel')}}
                    </div>
                    <div v-else>
                        {{translate('resetPasswordRequestAlreadyCanceled')}}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.$route.params.confirm == 'confirm'">
            <div class="user-info">
                <div class="user-info__wrapper" v-if="!confirmCodeAlreadyUsed">
                    <div class="user-info__title">
                        {{translate('changePasswordFormTitle')}}
                    </div>
                    <div class="user-info__first">
                        <div class="user-info__name">
                            {{this.userData.name}} {{this.userData.secondName}} ({{this.userData.email}})
                        </div>
                    </div>
                    <div class="input-wrapper">
                        <input class="sign-input" :type="type" v-model="signUp.password"
                               @focus="onPasswordFocus"
                               @blur="onPasswordFocusLost"
                               @input="validatePassword" required>
                        <label class="form-lable">{{translate('bi_new_password')}}</label>
                        <div class="show-password" @click="showPassword">
                            <div class="show-password__icon" v-if="type === 'password'">
                                <i class="far fa-eye"></i>
                            </div>
                            <div v-else>
                                <i class="far fa-eye-slash"></i>
                            </div>
                        </div>
                    </div>
                    <passwordValidation :settings='passwordValidationSettings'></passwordValidation>
                    <div class="input-wrapper">
                        <!--                        <div class="input-icon"><i class="fas fa-unlock-alt"></i></div>-->
                        <input class="sign-input" :type="type" v-model="newPassword"
                               @input="validatePassword" required>
                        <label class="form-lable">{{translate('bi_confirm_new_password')}}</label>
                        <div class="show-password" @click="showPassword">
                            <div class="show-password__icon" v-if="type === 'password'">
                                <i class="far fa-eye"></i>
                            </div>
                            <div v-else>
                                <i class="far fa-eye-slash"></i>
                            </div>
                        </div>
                    </div>
                    <div class="input-error" :class="{show: showError}">
                        {{translate('passwordDontMatch')}}
                    </div>
                    <div class="change-password__btn" :class="{block: this.signUp.password !== this.newPassword}" @click="onChangePasswordBtnClick">
                        {{translate('bi_change_password')}}
                    </div>
                </div>
                <div class="user-info__wrapper" v-else>
                    <div class="user-info__title">
                        {{translate('changePasswordFormTitle')}}
                    </div>
                    <div class="user-info__subtitle">
                        {{translate('signIn_codeAlreadyUsed')}}
                    </div>
                    <router-link :to="{name: 'Login'}" class="user-info__back-btn" >
                        {{translate('signIn_recoverPassBack')}}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import errorMixin from '@/mixins/errorMixin';
import passwordValidation from "@/components/widgets/passwordValidation";
import config from '@/api/config';
export default {
    name: "resetPasswordFlow",

    mixins: [mixin, errorMixin],

    data () {
        return {
            resetCancelCodeSuccess: false,
            userData : {
                name: '',
                secondName: '',
                email: '',
            },
            passwordValidationSettings: {
                validation: '',
                show: false,
            },
            type: 'password',
            signUp: {
                password: '',
            },
            newPassword: '',
            showError: false,
            confirmCodeAlreadyUsed: false
        }
    },

    components: {
        passwordValidation
    },
    watch: {
        'signUp.password'(item) {
            this.passwordValidationSettings.validation = item
        },
        'showError' (newValue) {
            this.showError = newValue
        }
    },
    mounted() {
      if (this.$route.params.confirm == 'cancel')  {
          this.checkCancelCodeAction()
      }
      if(this.$route.params.confirm == 'confirm') {
          this.checkConfirmCodeAction()
      }
    },
    computed: {
        ...mapGetters({
            isUserClient: 'auth/isUserClient',
            isUserOwner: 'auth/isUserOwner',
            isUserAdmin: 'auth/isUserAdmin',
            getOwnPlace: 'auth/getOwnPlace',
            isUserOrgManager: 'auth/isUserOrgManager',
            isUserSiteManager: 'auth/isUserSiteManager',
            getFormatedLang: 'getFormatedLang'
        })
    },
    methods : {
        ...mapActions({
            resetCancelCode: "auth/resetCancelCode",
            resetConfirmCode: "auth/resetConfirmCode",
            saveNewPassword: "auth/saveNewPassword",
            fetchUserInfo: 'auth/fetchUserInfo',
        }),
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
        }),
        async checkCancelCodeAction () {
            const body = {
                code: this.$route.params.reset_code
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'checkResetPasswordCancelCode'
                })
                const response = await this.resetCancelCode(body)
                if (response) this.resetCancelCodeSuccess = true
            } catch (e) {
                if(e.data.error.code == 1410){
                  console.log(e.data.error.code)
                  this.confirmCodeAlreadyUsed = true
                } else {
                  this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                  })
                }
                this.resetCancelCodeSuccess = false
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'checkResetPasswordCancelCode'
                })
            }
        },
        async checkConfirmCodeAction () {
            const body = {
                code: this.$route.params.reset_code
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'checkResetPasswordCode'
                })
                const response = await this.resetConfirmCode(body)
                this.userData.name = response.data.first_name
                this.userData.secondName = response.data.last_name
                this.userData.email = response.data.email
            } catch (e) {
                if(e.data.error.code == 1410){
                    console.log(e.data.error.code)
                    this.confirmCodeAlreadyUsed = true
                } else {
                    this.showErrorModal(e.data.error.message, {
                      title: 'Error',
                      code: e.data.error.code
                    })
                }
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'checkResetPasswordCode'
                })
            }
        },
        onPasswordFocus() {
            this.passwordValidationSettings.show = true
        },
        validatePassword () {
            if (this.signUp.password !== this.newPassword && this.newPassword !== '' || this.signUp.password !== '' && this.signUp.password !== this.newPassword) {
                this.showError = true
            } else {
                this.showError = false
            }
        },

        onPasswordFocusLost() {
            this.passwordValidationSettings.show = this.signUp.password !== ''
        },
        showPassword() {
            if (this.type === 'password') {
                this.type = 'password-text'
            } else {
                this.type = 'password'
            }
        },
        homePage() {
            window.open(`${config.siteUrl}/${this.$ml.current}`, '_blank').focus()
        },
        onChangePasswordBtnClick() {
            this.saveNewUserPasswordAction()
        },
        async saveNewUserPasswordAction () {
            const body = {
                code: this.$route.params.reset_code,
                password: this.newPassword
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'saveNewPassword'
                })
                const response = await this.saveNewPassword(body)
                if (response.data.access_token && response.data.refresh_token) {
                    console.log(`if (response.data.access_token && response.data.refresh_token) {`)
                    await this.setSignInState(response)
                    await this.fetchUserInfo()
                    await this.handleUserFlow()
                }
            } catch (e) {
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'saveNewPassword'
                })
            }
        },
        handleUserFlow() {
            console.log(`zzz this.isUserAdmin:${this.isUserAdmin} this.isUserOwner:${this.isUserOwner} ${this.getOwnPlace} this.isUserOrgManager:${this.isUserOrgManager} ${this.isUserSiteManager}`)
            if (this.isUserAdmin) {
                this.$router.push('/admin-panel')
            } else if ((this.isUserOwner && this.getOwnPlace) || (this.isUserOrgManager || this.isUserSiteManager)) {
                this.$router.push({name: 'OwnerPlaceManagement', params: {analyticActiveBool: true}})
            } else if (this.isUserOwner && !this.getOwnPlace) {
                this.$store.commit('owner/setOwner', true)
                this.$router.push({name: 'ownerBusinessFlow'});
            } else {
                //todo just a client-user
            }
        },
    }
}
</script>

<style scoped>
    .reset-status {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        color: white;
        font-size: 20px;
    }
    .face-rate {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        min-height: 100vh;
        padding-left: 5vw;
        padding-right: 5vw;
        /* padding-bottom: 15vh; */
        text-align: center;
        background: #F3F3F3;
    }
    .input-wrapper {
        display: flex;
        margin-top: 35px;
        position: relative;
        vertical-align: top;
        align-items: baseline;
        max-width: 315px;
        min-width: 315px;
    }
    .sign-input {
        color: white;
        border-bottom: 3px solid #ffffff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 5px;
    }
    .user-info__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    input {
        outline: none;
        color: #fff;
        border: none;
        background-color: #3f405c;
        width: 100%;
        cursor: pointer;
    }
    label {
        margin-bottom: 0!important;
        cursor: default;
        position: relative;
        width: 100%;
        color: #fff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        text-align: start;
    }
    .input-icon {
        color: #FFFFFF;
        margin-right: 8px;
        height: 14px;
        width: 18px;
        margin-top: 3px;
    }

    .sign-input:focus ~ .form-lable,
    .sign-input:not(:focus):valid ~ .form-lable {
        font-size: 15px;
        top: -20px;
    }

    .sign-input:focus ~ .form-lable__last-name,
    .sign-input:not(:focus):valid ~ .form-lable__last-name {
        top: -20px;
        font-size: 15px;
    }

    .form-lable {
        position: absolute;
        pointer-events: none;
        left: 0;
        top: 0px;
        transition: .3s;
    }
    .show-password {
        position: absolute;
        left: 285px;
        top: 4px;
        color: white;
        cursor: pointer;
    }
    .header-logo {
        margin-top: 14px;
        cursor: pointer;
        margin-bottom: 26px;
    }
    .user-info {
        display: flex;
        justify-content: center;
        width: 594px;
        border-radius: 16px;
        background-color: #3F405C;
        padding-bottom: 40px;
    }
    .user-info__title {
        margin-top: 25px;
        margin-bottom: 25px;
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-decoration: none;
        outline: none;
    }
    .user-info__subtitle {
        margin-top: 50px;
        margin-bottom: 75px;
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-decoration: none;
        outline: none;
    }
    .user-info__back-btn {
        color: #FFBF00 !important;
        font-family: Nunito;
        font-weight: 700;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        cursor: pointer;
    }
    .user-info__back-btn:hover {
        outline: none;
        text-decoration: none;
    }
    .user-info__first {
        display: flex;
    }
    .user-info__name {
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 17px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        margin-right: 25px;
        word-break: break-all;
    }
    .user-info__second-name {
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
    }
    .user-info__email {
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-align: left;
        margin-top: 20px;
    }
    .password-icons {
        margin-top: 0;
        margin-left: 0;
    }
    .input-error {
        color: red;
        text-align: left;
        margin-top: -10px;
        display: none;
    }
    .input-error.show {
        display: block;
    }
    .change-password__btn {
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        border-radius: 6px;
        background-color: #FFBF00;
        box-shadow: 0 2px 8px 0 #FFBF00;
        padding: 12px;
        margin-top: 25px;
        cursor: pointer;
        max-width: 315px;
        min-width: 315px;
    }
    .change-password__btn.block {
        background-color: #2F2F2F;
        box-shadow: 0 2px 8px 0 #2F2F2F;
        color: #FFFFFF;
        pointer-events: none;
        cursor: not-allowed;
    }
</style>